<template lang="html">
    <div>
        <div class="loader-wrap" v-if="!loaded">
            <div class="loader-content">
                <div class="loader">
                    <div class="loader__item">
                    </div>
                </div>
            </div>
        </div>

       <div class="content" v-else>
           <h1>Import do vyúčtování majitelům licencí - kontrola</h1>

           <div v-if="!imported">
               <div v-if="allData.filter(all => all.status === 'not_found').length > 0">
                   Některé audioknihy obsahují chybu, nebo neexistují opravdu si přejete provést import dat? Zmíněné audioknihy budou vyřezany z importu.
               </div>
               <div v-if="allData.filter(all => all.status === 'not_found').length === 0">
                   Všechny audioknihy jsme nalezli, přejete si provést import?
               </div>
               <div>
                   <v-btn
                           v-if="allData.filter(all => all.status === 'not_found').length > 0"
                           color="error"
                           class="button--primary"
                           @click="importData()"
                   >
                       importovat
                   </v-btn>
                   <v-btn
                           v-if="allData.filter(all => all.status === 'not_found').length === 0"
                           color="primary"
                           class="button--primary"
                           @click="importData()"
                   >
                       importovat
                   </v-btn>
               </div>
               <div>
                   <div v-if="allData.filter(all => all.status === 'not_found').length > 0">
                       <h2>Nenalezené audioknihy</h2>
                       <div class="import-row import-row--failed" v-for="item in allData.filter(all => all.status === 'not_found')">
                         {{item.count}}x <b>{{item.audiobook}}</b> ({{item.price}}Kč)
                       </div>
                   </div>
                   <div v-if="allData.filter(all => all.status === 'no_licence').length > 0">
                     <h2>Není vyplněn majitel licence v detailu audioknihy</h2>
                     <div class="import-row import-row--failed" v-for="item in allData.filter(all => all.status === 'no_licence')">
                       {{item.count}}x <b>{{item.audiobook}}</b> ({{item.price}}Kč)
                     </div>
                   </div>
                   <div v-if="allData.filter(all => all.status === 'found').length > 0">
                       <h2>Nalezené audioknihy</h2>
                       <div class="import-row import-row--success" v-for="item in allData.filter(all => all.status === 'found')">
                         {{item.count}}x <b>{{item.audiobook}}</b> ({{item.price}}Kč)
                       </div>
                   </div>
               </div>
           </div>
           <div v-if="imported">
               <div v-if="importedSuccess">
                   Knihy byly úspěšně importovány.
               </div>
               <div v-else>
                   Při importování nastala chyba.<br>
                   <v-btn
                           color="primary"
                           class="button--primary"
                           @click="importData()"
                   >
                       importovat znovu
                   </v-btn>
               </div>
           </div>



       </div>
    </div>
</template>


<script>
    import { mapState } from 'vuex';
    import moment from 'moment'

    export default {
        name: 'Settings',
        components: {
        },



        data() {
            return {
                years: [],
                loaded: false,
                banners: [],
                errors: {},
                imageUploaded: true,
                currentYear: null,
                items: [],
                publishers: [],
                publisher: null,
                allData: [],
                imported: false,
                importedSuccess: true
            }
        },

        created() {

            this.checkData();
            
        },
        computed: {
            ...mapState(['profile','import', 'importValues']),

        },
        mounted(){
            //this.loaded = true;
        },
        methods: {
            checkData(){

                this.imported = false;
                if(this.import.length == 0 || !this.importValues.date){
                    this.$router.push({name: 'BillingImport'});
                    return;
                }
                var request = {
                    data: this.import,
                    values: this.importValues
                }
                this.$axios.post('/admin/import/check', request).then((response) => {
                    this.allData = response.data.checked;

                    this.loaded = true;

                }).catch((e) => {

                    this.loaded = true;
                });
            },
            importData(){
                this.loaded  = false;
                this.imported = true;

                var request = {

                    data: this.import,
                    values: this.importValues
                }
                this.$axios.post('/admin/import/make', request).then((response) => {
                    this.allData = response.data.checked;

                    this.importedSuccess = true;
                    this.loaded = true;

                }).catch((e) => {
                    this.importedSuccess = false;
                    this.loaded = true;
                });
            }

        },
        watch: {

        }
    }
</script>


<style lang="scss">


</style>
